export interface IPagination {
    page: number;
    rowsPerPage: number;
}

const defaultRowsPerPage: number = 10;

export const defaultControllerPagination: IPagination = {
    page: 0,
    rowsPerPage: defaultRowsPerPage
}